<script lang="ts">
  import { type TransitionConfig } from "svelte/transition"
  import Frame from "./Frame"

  export let complete = false

  export let transition: (node: Element) => TransitionConfig = () => ({})
</script>

<div
  class:circle-scan-frame={/* anchor for external customization */ true}
  class:complete
  transition:transition|local
>
  <Frame.Backdrop />
  <Frame />
  <slot />
</div>

<style lang="postcss">
  * {
    @apply relative flex h-full w-full items-center justify-center;

    /* Ellipse frame */
    &.complete > :global(*:nth-child(2)) {
      @apply text-[#B5FF6A];
    }

    /* Child: YawIndicator or PitchIndicator */
    & > :global(*:nth-child(3)) {
      @apply absolute left-1/2 -translate-x-1/2;
    }
  }
</style>
